import { ButtonConfig, ButtonVariant } from "src/app/common/components/core/button/button.component";

export class Constants {
  static readonly STG = 'stg';
  static readonly LTG = 'ltg';
  static readonly underlying = 'underlying';
  static readonly certificationFrom = '_CertificationFrom';
  static readonly certificationThru = '_CertificationThru';
  static readonly EvaluationOnly = 'EvaluationOnly';
  static readonly undefined = 'undefined';
  static readonly comments = 'comments';
  static readonly DischargeReturnToPriorQuestionId = "MedicalInformation_DischargeEnvironmentalAndPlan_Main_ReturnToTheirPriorResidence"
  static readonly UnderlyingImpairmentsMainPlof = "UnderlyingImpairments_UnderlyingImpairments_Main_PriorLevelofFunction";
  static readonly UnderlyingImpairmentMainStgStatus = "UnderlyingImpairments_UnderlyingImpairments_Main_STGStatus";
  static readonly UnderlyingImpairmentMainLtgStatus = "UnderlyingImpairments_UnderlyingImpairments_Main_LTGStatus";
  static readonly UnderlyingImpairmentsMainCurrentFunction = "UnderlyingImpairments_UnderlyingImpairments_Main_CurrentFunction";
  static readonly UnderlyingImpairmentsSelectedToPOC = "UnderlyingImpairments_UnderlyingImpairments_Main_SelectToPOC";
  static readonly UnderlyingImpairmentsViewPlof = "UnderlyingImpairments_UnderlyingImpairments_Main_Panel_Actions_ViewGoal_PLOF";
  static readonly UnderlyingImpairmentsViewCurrentFunction = "UnderlyingImpairments_UnderlyingImpairments_Main_Panel_Actions_ViewGoal_CurrentFunction";
  static readonly UnderlyingImpairmentsViewComments = "UnderlyingImpairments_UnderlyingImpairments_Main_Panel_Actions_ViewGoal_Comments"
  static readonly FunctionalLimitionsMainPlof = "FunctionalLimitationsAndGGSections_FunctionalLimitations_Main_PriorLevelofFunction";
  static readonly FunctionalLimitionsMainCurrentFunction = "FunctionalLimitationsAndGGSections_FunctionalLimitations_Main_CurrentFunction";
  static readonly PriorHospitalizationToDateQuestionId = "MedicalInformation_PriorHospitalization_Main_ToDate";
  static readonly PriorHospitalizationNotApplicableQuestionId = "MedicalInformation_PriorHospitalization_Main_NotApplicable";
  static readonly NotApplicableSummaryText = "NA";
  static readonly ViewButtonConfig: ButtonConfig = {
    text: "View Goal",
    variant: ButtonVariant.PRIMARY_OUTLINE,
  };
  static readonly ViewPreviousButtonConfig: ButtonConfig = {
    text: "View Previous",
    variant: ButtonVariant.PRIMARY_OUTLINE,
  };
  static readonly AddGoalButtonConfig: ButtonConfig = {
    text: "Add Goals",
    variant: ButtonVariant.PRIMARY_OUTLINE
  };
  static readonly UpdateGoalButtonConfig: ButtonConfig = {
    text: "Update Goals",
    variant: ButtonVariant.PRIMARY_OUTLINE
  }
  static readonly UpdateSTGGoalButtonConfig: ButtonConfig = {
    text: "Update STG Goal",
    variant: ButtonVariant.PRIMARY_OUTLINE,
  };
  static readonly UpdateLTGGoalButtonConfig: ButtonConfig = {
    text: "Update LTG Goal",
    variant: ButtonVariant.PRIMARY_OUTLINE,
  };
  static readonly NewSTGGoalButtonConfig: ButtonConfig = {
    text: "Add new short term goal",
    variant: ButtonVariant.PRIMARY_OUTLINE,
  };
  static readonly NewLTGGoalButtonConfig: ButtonConfig = {
    text: "Add new long term goal",
    variant: ButtonVariant.PRIMARY_OUTLINE,
  };
  static readonly CancelButtonConfig: ButtonConfig = {
    text: 'Cancel',
    variant: ButtonVariant.SECONDARY_OUTLINE,
  };
  static readonly AddNewSTG: ButtonConfig = {
    text: 'Add STG',
    variant: ButtonVariant.PRIMARY_OUTLINE,
  };
  static readonly AddNewLTG: ButtonConfig = {
    text: 'Add LTG',
    variant: ButtonVariant.PRIMARY_OUTLINE,
  };
  static readonly UpdateSTG: ButtonConfig = {
    text: 'Update STG',
    variant: ButtonVariant.PRIMARY_OUTLINE,
  };
  static readonly UpdateLTG: ButtonConfig = {
    text: 'Update LTG',
    variant: ButtonVariant.PRIMARY_OUTLINE,
  };
  static readonly NoDailyNotesMessage = 'No Daily Notes have been added';
  static readonly IsNotesClickableText = 'isNotesClickable';
  static readonly AddOneTreatmentDailyNotesText = 'Add One Treatment Daily Notes';
  static requiredErrorText = (field : string) => `${field} is required`;
}

export const ConfirmationModalConstants = {
  ErrorTitle: "Error",
  WarningTitle: "<span class='text-red-500'>Warning</span>",
  OkButtonText: "Ok",
}

export const GOAL_TYPE = {
  STG: "STG",
  LTG: "LTG",
}

export const GoalsConstants = {
  PLOF_IDENTIFIER : "PriorLevelofFunction",
  CF_IDENTIFIER : "CurrentFunction",
  LONG_TERM_GOAL_IDENTIFIER : "LongTerm",
  SHORT_TERM_GOAL_IDENTIFIER : "ShortTerm",
}

export const SUMMARY_DEPENDENCY_ACTION = {
  OVERWRITE: "Overwrite",
  CLEAR: "Clear",
}